<template>
  <div class="root_page">
    <div class="table_wrapper">
      <div class="ctrl-wrapper">
        <div class="search_wrapper">
          <div class="common_search_wrapper">
            <Input class="search-ipt" type="text" v-model="searchIpt.keyword" placeholder="请输入班主任姓名或邀请码" clearable/>
            <Button type="primary" icon="md-search" class="search_tn" data-level="common" @click="getClassesList">搜索</Button>
            <Button class="top_search_btn" type="primary" ghost icon="ios-funnel" @click="topSearchStatus = true">高级搜索</Button>
          </div>
        </div>
      </div>
      <Table class="main_table" size="large" stripe border :columns="tableHeader" :data="tableData">
        <template slot-scope="{row}" slot="code">
          <div class="jump_color" @click="seeWxCode(row.id,row.code)">{{row.code}}</div>
        </template>
        <template slot-scope="{ row, index}" slot="studentCount">
          <div :class="[row.studentCount?'jump_color':'']" @click="toStudents(row.id,row.studentCount)">{{row.studentCount}}</div>
        </template>
        <template slot-scope="{row}" slot="teacherCount">
          <div :class="[row.teacherCount?'jump_color':'']" @click="toUsers(row.id,row.teacherCount)">{{row.teacherCount}}</div>
        </template>
        <template slot-scope="{ row, index}" slot="manager">
          <div class="jump_color" @click="toUserDetail(row.manager)">{{row.manager}}</div>
        </template>
        <template slot-scope="{row}" slot="action">
          <div class="jump_color" @click="checkDetail(row.id)">详情</div>
        </template>
      </Table>
    </div>
    <paging :totalNum="totalNum" :pageSize="pageSize" @pageCallback="getClassesList"></paging>
    <Modal class="top_search_modal" v-model="topSearchStatus" title="高级搜索">
      <div class="top_search_wrapper">
        <Input class="search-ipt search_item" type="text" v-model="searchIpt.seniorKeyword" placeholder="请输入班主任姓名或邀请码" clearable/>
        <Input class="search-ipt search_item" type="text" v-model="searchIpt.classId" placeholder="请输入班级ID" clearable/>
        <Input class="search-ipt search_item" type="text" v-model="searchIpt.schoolName" placeholder="请输入学校名称" clearable/>
        <Input class="search-ipt search_item" type="text" v-model="searchIpt.className" placeholder="请输入班级名称" clearable/>
      </div>
      <div class="ctrl-footer" slot="footer">
        <Button class="closed_btn" @click="topSearchStatus = false">取消</Button>
        <Button class="add_record_btn" type="info" icon="md-search" @click="topSearchFn">搜索</Button>
      </div>
    </Modal>
    <Modal v-model="wxCodeModalStatus" title="邀请码">
      <img class="wxCode_img" :src="wxCodeUrl" alt="">
      <div class="ctrl-footer" slot="footer">
        <Button class="closed_btn" @click="wxCodeModalStatus = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import {_getClassesList,_getWxCode} from '../api/api';
  import paging from '../templates/Paging.vue';

  export default {
    name:"Klasses",
    components: {
      paging
    },
    data() {
      return {
        pageSize: 10, // 每页条数
        totalNum: 0, // 数据总条数
        searchLevel: 'common',// common普通搜索，senior高级搜索
        topSearchStatus: false, // 高级搜索显示状态
        wxCodeUrl: '',//班级邀请码链接
        wxCodeModalStatus:false, // 邀请码模态框
        wxCodeNum: '',//邀请码
        tableData: [], //表格数据
        searchIpt: {
          keyword: '',
          seniorKeyword: '',
          className: '',
          schoolName: '',
          classId: ''
        },
        //表头
        tableHeader: [
          {
            title: 'ID',
            key: 'id'
          },
          {
            title: '学校',
            key: 'schoolName'
          }
          , {
            title: '班级名称',
            key: 'className'
          }, {
            title: '邀请码',
            key: 'code',
            slot: 'code'
          },
          {
            title: '学生人数',
            key: 'studentCount',
            slot: 'studentCount'
          },
          {
            title: '学生绑定率',
            key: 'studentBindRate',
          },
          {
            title: '老师人数',
            key: 'teacherCount',
            slot: 'teacherCount'
          }
          , {
            title: '班主任',
            key: 'manager',
            slot: 'manager'
          }, {
            title: '操作',
            key: 'action',
            slot: 'action'
          }

        ],
      }
    },
    methods: {
//      获取班级列表
      getClassesList(msg) {
        const self = this;
        let params = {
          name: self.searchIpt.className,
          id:self.searchIpt.classId,
          code: self.searchLevel === 'common' ? (/^\d*$/gi.test(self.searchIpt.keyword) ? self.searchIpt.keyword : '') : (/^\d*$/gi.test(self.searchIpt.seniorKeyword) ? self.searchIpt.seniorKeyword : ''),
          managerName: self.searchLevel === 'common' ? (/^\d*$/gi.test(self.searchIpt.keyword) ? '' : self.searchIpt.keyword) : (/^\d*$/gi.test(self.searchIpt.seniorKeyword) ? '' : self.searchIpt.seniorKeyword),
          schoolName: self.searchIpt.schoolName,
          page: typeof(msg) === 'object' && msg.pageNum ? msg.pageNum - 1 : 0,
          size: self.pageSize
        };
        _getClassesList({params: params}).then(res => {
          if (res.code === 0) {
            self.tableData = res.data.content;
            self.totalNum = res.data.total;
            self.tableData.length && self.tableData.forEach(item => {
              item.className = item.grade + item.name;
              item.studentBindRate = Math.round(item.studentBindRate/100) + '%';
            })
          }
        })
      },
//      高级搜索
      topSearchFn() {
        this.searchLevel = "senior";
        this.getClassesList();
        this.searchIpt = {
          keyword: '',
          seniorKeyword: '',
          className: '',
          schoolName: '',
          classId: ''
        };
        this.topSearchStatus = false;
      },
//      查看班级邀请，
      seeWxCode(classId,code) {
        const self = this;
        self.wxCodeNum = code;
        self.wxCodeModalStatus = true;
        _getWxCode(classId).then(res => {
          if(res.code === 0) {
            self.wxCodeUrl = res.data;
          }
        })
      },
//      跳转到学校管理
      toStudents(classId,num) {
        if(num) {
          this.$router.push(`/students?classId=${classId}`);
        }
      },
//      跳转到用户管理
      toUsers(classId,num) {
        if(num) {
          this.$router.push(`/user?cId=${classId}`)
        }
      },
//      跳转到用户列表
      toUserDetail(manager) {
        this.$router.push(`/user?name=${manager}`);
      },
//      跳转倒详情
      checkDetail(classId) {
        this.$router.push(`/klasses/detail?id=${classId}`);
      }
    },
    created() {
      if(this.$route.query.schoolName) {
        this.searchIpt.schoolName = this.$route.query.schoolName;
      }
      if(this.$route.query.classId) {
        this.searchIpt.classId = this.$route.query.classId;
      }
    },
    mounted() {
      this.getClassesList();
    }
  };
</script>
<style>
.wxCode_img{
  display: block;
  width:260px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Klasses.vue